module.exports = "<p>showcase-festivities-f2010 works!</p>\n"